/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IdpSubmissionResponse } from '../../models/idp-submission-response';

export interface ApiIdpSubmissionsDirectGet$Plain$Params {
  id?: number;
  details?: string;
}

export function apiIdpSubmissionsDirectGet$Plain(http: HttpClient, rootUrl: string, params?: ApiIdpSubmissionsDirectGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<IdpSubmissionResponse>> {
  const rb = new RequestBuilder(rootUrl, apiIdpSubmissionsDirectGet$Plain.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('details', params.details, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IdpSubmissionResponse>;
    })
  );
}

apiIdpSubmissionsDirectGet$Plain.PATH = '/api/idp/submissions-direct';
